// components/playground/sections/SaveScenarioModal.jsx
import React, { useState, useEffect } from 'react';
import Modal from '../../../common/Modal';
import { getButtonClass, getInputClass, getAlertClass, MODAL_THEME } from '../../../../config/theme.config';
const SaveScenarioModal = ({
  isOpen,
  onClose,
  onSave,
  mode = 'new',
  initialName = '',
  initialDescription = '',
  isSaving = false,
}) => {
  const [name, setName] = useState(initialName);
  const [description, setDescription] = useState(initialDescription);

  useEffect(() => {
    if (isOpen) {
      setName(initialName);
      setDescription(initialDescription);
    }
  }, [isOpen, initialName, initialDescription]);

  const handleSave = () => {
    if (!name.trim()) return;
    onSave({ name: name.trim(), description: description.trim() });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && e.metaKey && name.trim()) {
      handleSave();
    }
  };

  const getTitle = () => {
    if (mode === 'rename') return 'Rename Scenario';
    if (mode === 'saveAs') return 'Save as New Scenario';
    return 'Save Scenario';
  };

  const getButtonText = () => {
    if (mode === 'rename') return 'Rename';
    return 'Save';
  };

  const getHelperText = () => {
    if (mode === 'rename') {
      return 'This will only update the scenario name. Your data and assumptions remain unchanged.';
    }
    return 'This will save your current adjustments and custom line items as a new scenario.';
  };

  const footer = (
    <>
      <button
        onClick={onClose}
        disabled={isSaving}
        className={getButtonClass('secondary')}
      >
        Cancel
      </button>
      <button
        onClick={handleSave}
        disabled={!name.trim() || isSaving}
        className={getButtonClass('primary')}
      >
        {isSaving ? (
          <>
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin inline-block mr-2" />
            Saving...
          </>
        ) : (
          getButtonText()
        )}
      </button>
    </>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={getTitle()}
      footer={footer}
      size="sm"
      closeOnBackdropClick={!isSaving}
      closeOnEscape={!isSaving}
    >
      <div className="space-y-4">
        {/* Name Input */}
        <div>
          <label className={MODAL_THEME.forms.label}>
            Scenario Name <span className={MODAL_THEME.forms.required}>*</span>
          </label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="e.g., Q1 Conservative Growth"
            className={getInputClass()}
            autoFocus
            disabled={isSaving}
          />
        </div>

        {/* Description */}
        {mode !== 'rename' && (
          <div>
            <label className={MODAL_THEME.forms.label}>
              Description (optional)
            </label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Describe your assumptions and changes..."
              rows={3}
              className={MODAL_THEME.forms.textarea}
              disabled={isSaving}
            />
          </div>
        )}

        {/* Helper Text */}
        <div className={getAlertClass('info')}>
          <p className="text-xs text-brightblue-800">
            {getHelperText()}
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default SaveScenarioModal;